// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const HeatmapIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="HeatmapIcon" ref={forwardedRef} {...props}>
      <path d="M4.5 3H3v13a1 1 0 0 0 1 1h13v-1.5H4.5z" />
      <path d="M6 10h11v4H6zm5.207 1.25-1.5 1.5h2.336l1.5-1.5zm-1.414 0H7.25v1.5h1.043zm3.664 1.5h2.293v-1.5h-.793z" />
      <path d="M12 4.5v4h5v-4zm3.75 1.25v1.5h-2.5v-1.5z" />
      <path d="M6 8.5h4.75v-4H6z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const HeatmapIcon = /* @__PURE__ */ Object.assign(HeatmapIconComponent, {
  displayName: 'HeatmapIcon',
});
